
/* injects from baggage-loader */

export const balloons = [
    'Para se tornar um chef, <br> é preciso que você conheça <br>pratos típicos de várias regiões. Vamos começar pela Região <b>Nordeste</b>.',
    'O Nordeste é conhecido por suas belas praias, por sua gente <br> hospitaleira e por sua <br> deliciosa <b>culinária</b>.',
    'Para conhecer estas comidas, <br> você começará como <b>Cliente</b>. <br> Sua função é escolher alguns <br> pratos e ordená-los ao Garçom.',
    'Leia e faça um pedido. Você <br> deve escolher somente uma <br> opção de cada seção: 1 entrada, <br> 1 prato principal, 1 sobremesa e <br> 1 bebida!',
]


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.const.js